/**
 * @name Participants
 * @description Function for the participants service
 * @param {type} $http Description
 * @param {constant} ENDPOINT Description
 * @param {service} AlertMessages Description
 * @param {service} Session Description
 * @param {service} Events The Events service
 * @param {library} _ The Lodash libary
 * @return {object} Returns the service
 */
function Participants(
  $http,
  ENDPOINT,
  AlertMessages,
  Session,
  Events,
  _
) {
  // Public functions
  Participants.get = get;
  Participants.create = create;
  Participants.update = update;
  Participants.remove = remove;
  Participants.getUnreadCount = getUnreadCount;

  /**
   * @name get
   * @description Function to get an array of participans of a
   * conversation
   * @param {number} conversationId The ID of the converstation to
   * retrieve the participants
   * @param {number} appointmentId The ID of the appointment to
   * retrieve the participants
   * @param {number} collectorId The ID of the collector to
   * retrieve the participants
   * @param {boolean} read The boolean for the read field filter
   * @param {number} page The page number of the paginated results
   * @param {string} sort Field to sort by
   * @param {string} last_message Filter by the last_message field. Options are
   * `notnull`
   * @return {array} Returns the an array of participants
   */
  function get(
    conversationId,
    appointmentId,
    collectorId,
    read,
    page,
    sort,
    last_message) {
    let url = ENDPOINT.server + 'conversations/api/v1.1/participants/';
    let role = Session.activeState.role;
    url += '?role=' + role;
    if (conversationId) {
      url += '&conversation_id=' + conversationId;
    }
    if (appointmentId) {
      url += '&appointment_id=' + appointmentId;
    }
    if (collectorId) {
      url += '&collector_id=' + collectorId;
    }
    if (!_.isUndefined(read)) {
      url += '&read=' + read;
    }
    if (!_.isUndefined(page)) {
      url += '&page=' + page;
    }
    if (!_.isUndefined(sort)) {
      url += '&sort=' + sort;
    }
    if (!_.isUndefined(last_message)) {
      url += '&last_message=' + last_message;
    }
    if (Session.activeState.association) {
      let associationId = Session.activeState.association.id;
      url += '&association_id=' + associationId;
    }
    return $http.get(url).then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name create
   * @description Function to create a participant
   * @param {object} participant The participant to create
   * @return {object} Returns the participant
   */
  function create(participant) {
    return $http.post(ENDPOINT.server +
    'conversations/api/v1.1/participants/', participant)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name update
   * @description Function to update a participant
   * @param {object} participant The participant to update
   * @return {object} Returns the participant
   */
  function update(participant) {
    return $http.put(ENDPOINT.server +
    'conversations/api/v1.1/participants/' + participant.id + '/', participant)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name remove
   * @description Function to delete a participant
   * @param {object} participantId The participant to delete
   * @return {object} Returns the function
   */
  function remove(participantId) {
    return $http.delete(ENDPOINT.server +
    'conversations/api/v1.1/participants/' + participantId + '/')
    .then(function() {
      // Intentionally left blank
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name getUnreadCount
   * @description Function to get an unread count for participants
   * @return {string} Returns the count
   */
  function getUnreadCount() {
    let url = ENDPOINT.server +
    'conversations/api/v1.1/participants/?unread_count=true';
    let role = 'collector';
    if (Session.hasOwnProperty('activeState') && Session.activeState.hasOwnProperty('role') &&
        Session.activeState.role) {
            role = Session.activeState.role;
    }
    url += '&role=' + role;
    if (Session.hasOwnProperty('activeState') && Session.activeState.hasOwnProperty('association') &&
        Session.activeState.association) {
      let associationId = Session.activeState.association.id;
      url += '&association_id=' + associationId;
    }
    return $http.get(url).then(function(response) {
      return response.data;
    });
  }
  return Participants;
}

angular
  .module('inkfinder')
  .factory('Participants', Participants);



// WEBPACK FOOTER //
// ./components/messages/participants/participants.service.js